// --- Estado de envío gratis (calculadora de CP) ---
let gfFreeState = { free: false, reason: '' };

// Escuchar los eventos que manda gf-shipping-calculator.js
document.addEventListener('gf:free-shipping-changed', (e) => {
  gfFreeState = { free: !!e.detail?.free, reason: e.detail?.reason || '' };
  updateOfferProgress(); // refrescar la barra amarilla
});


// --- Gordito Fit: progreso de ofertas (solo texto) ---
async function fetchCart() {
  try {
    const r = await fetch('/cart.js', { credentials: 'same-origin' });
    return await r.json();
  } catch (e) {
    return { item_count: 0 };
  }
}

// function buildMessage(count) {
//   const n = Number(count) || 0;

//   // 1) Si la calculadora ya determinó envío gratis, priorizamos ese mensaje
//   if (gfFreeState.free) {
//     return `<span class="strong">🚚 Envío GRATIS — ${gfFreeState.reason || 'aplicado para tu zona'}</span>`;
//   }

//  // 2) Si no aplica por CP, usamos la regla por cantidad
//   if (n <= 0) return '<span class="strong">Agrega 2 productos y obtén envío con 50% de descuento.<br> Agrega 3 y el envío es GRATIS.</span>';
//   if (n === 1) return '<span class="strong">Tu envío: $100 MXN — Agrega 1 producto más y baja a $50.<br> Agrega 2 para ENVÍO GRATIS.</span>';
//   if (n === 2) return '<span class="strong">Tu envío ahora es de $50.<br> Agrega 1 producto más y obtén ENVÍO GRATIS.</span>';
//   return '<span class="strong"> ✈️ ¡Ya tienes envío gratis!</span>';
// }

function buildMessage(count) {
  const n = Number(count) || 0;

  if (n === 3) {
    return '<span class="strong">🚚 ¡Ya tienes envío GRATIS!<br>Agrega una cuarta playera y la quinta va por nuestra cuenta.</span>';
  }

  if (n === 4) {
    return '<span class="strong">🚚 ¡Tu envío es GRATIS!<br>¡Elige tu quinta playera y agrégala GRATIS!</span>';
  }

  if (n >= 5) {
    return '<span class="strong">🎉 ¡Envío GRATIS y quinta playera GRATIS!</span>';
  }

  // Conservamos el envío gratis por CP para cantidades menores
  if (gfFreeState.free) {
    return `<span class="strong">🚚 Envío GRATIS — ${gfFreeState.reason || 'aplicado para tu zona'}</span>`;
  }

  //  if (n <= 0) return '<span class="strong">Agrega 2 productos y obtén envío ENVÍO GRATIS.</span>';
  // if (n === 1) return '<span class="strong">Tu envío: $100 MXN — Agrega 2 producto más y obtén ENVÍO GRATIS.</span>';
  //  if (n === 2) return '<span class="strong">Tu envío ahora es de $100.<br>Agrega 1 producto más y obtén ENVÍO GRATIS.</span>';
  //}

if (n <= 0)  return '<span class="strong">¡Envío gratis al comprar 3 playeras!</span>';
if (n === 1) return '<span class="strong">Tu envío cuesta $100 MXN.<br>Agrega 2 playeras más y obtén ENVÍO GRATIS.</span>';
if (n === 2) return '<span class="strong">Tu envío cuesta $100 MXN.<br>Agrega 1 playera más y obtén ENVÍO GRATIS.</span>';
}






async function updateOfferProgress() {
  const el = document.getElementById('offer-progress-drawer');
  if (!el) return;
  const cart = await fetchCart();
  el.innerHTML = String(buildMessage(cart.item_count || 0) ?? '');
}

// Utilidad: evita spamear updates seguidos
function debounce(fn, wait = 250) {
  let t;
  return (...args) => {
    clearTimeout(t);
    t = setTimeout(() => fn(...args), wait);
  };
}
const updateOfferProgressDebounced = debounce(updateOfferProgress, 300);

// --- Listeners comunes en Dawn / AJAX cart ---
document.addEventListener('DOMContentLoaded', updateOfferProgress);
document.addEventListener('cart:updated', updateOfferProgressDebounced);
document.addEventListener('cart:refresh', updateOfferProgressDebounced);
document.addEventListener('shopify:section:load', updateOfferProgress);

// Abrir drawer
document.addEventListener('cart-drawer:open', updateOfferProgress);

// Clicks en botones de “add/quitar” dentro del drawer
document.body.addEventListener('click', (e) => {
  const btn = e.target.closest('button, a');
  if (!btn) return;
  const id = (btn.id || '') + ' ' + (btn.className || '');
  if (/cart|add|plus|minus|remove|quick-add/i.test(id)) {
    updateOfferProgressDebounced();
    setTimeout(updateOfferProgressDebounced, 700); // segundo update tras el AJAX
  }
});

// Por si el theme no emite eventos, observa cambios en el drawer
const drawer = document.querySelector('cart-drawer, .cart-drawer, #CartDrawer');
if (drawer && 'MutationObserver' in window) {
  new MutationObserver(() => updateOfferProgressDebounced())
    .observe(drawer, { childList: true, subtree: true });
}

